import { useState } from 'react'

import { SwitchButtonGroup } from 'components/ui'

import { Title, Article, Content, ContentTitle, SelectorWrap, TitleList, List, ListItem } from './Style'

const GROUP_NAME = 'button-types-tutorial'

const Tutorial = () => {
  const [isSelect, setSelect] = useState('metamask')

  const SENDING_VALUE = [
    {
      name: GROUP_NAME,
      label: 'Metamask',
      value: 'metamask',
    },
    {
      name: GROUP_NAME,
      label: 'Self generated',
      value: 'selfGenerated',
    },
  ]

  const sendingHandler = (value: string) => {
    setSelect(value)
  }

  return (
    <>
      <Title>_tutorial</Title>
      <Article>
        <Content>
          <ContentTitle>
            Sending tokens to&nbsp;multiple addresses
            <br />
            Step-by-step guide
          </ContentTitle>
          <SelectorWrap>
            <SwitchButtonGroup<string> checked={isSelect} options={SENDING_VALUE} onChange={sendingHandler} />
          </SelectorWrap>

          {isSelect === 'metamask' && (
            <>
              <TitleList>1-prepare</TitleList>
              <List>
                <ListItem>
                  Connect your wallet to&nbsp;<b>_mad-assembly</b>.
                </ListItem>
                <ListItem>Select the network you want.</ListItem>
                <ListItem>
                  Select your token and provide a&nbsp;list of&nbsp;addresses in&nbsp;CSV&nbsp;/ XLS&nbsp;/ XLSX format;
                  if&nbsp;you don&rsquo;t know which format to&nbsp;provide, click &rsquo;_example&rsquo;
                  or&nbsp;download an&nbsp;example CVS file.
                </ListItem>
                <ListItem>Click &rsquo;_continue&rsquo; and proceed to&nbsp;the next step.</ListItem>
              </List>

              <TitleList>2-approve</TitleList>
              <List>
                <ListItem>
                  Click the &rsquo;service conditions&rsquo; checkbox and then the &rsquo;_continue&rsquo; button.
                </ListItem>
                <ListItem>
                  Before the dApp checks all the conditions, confirm the approve transaction in&nbsp;your wallet. Please
                  take into account that depending on your token setup you might need to sign two separate transactions
                  - revoke and approve.
                </ListItem>
                <ListItem>
                  Please wait until the transaction is&nbsp;completed and click &rsquo;_continue&rsquo; &nbsp; to
                  proceed to the <b>Airdrop step</b>.
                </ListItem>
              </List>

              <TitleList>3-airdrop</TitleList>
              <List>
                <ListItem>Select &rsquo;Metamask&rsquo; option and click &rsquo;_continue&rsquo;.</ListItem>
                <ListItem>
                  Airdrop step displays the complete airdrop information. Click &rsquo;_proceed&rsquo; and confirm the
                  transactions in&nbsp;your wallet.
                </ListItem>
                <ListItem>Finished!</ListItem>
              </List>
            </>
          )}

          {isSelect === 'selfGenerated' && (
            <>
              <TitleList>1-prepare</TitleList>
              <List>
                <ListItem>
                  Connect your wallet to&nbsp;<b>_mad-assembly</b>.
                </ListItem>
                <ListItem>Select the network you want.</ListItem>
                <ListItem>
                  Select your token and provide a&nbsp;list of&nbsp;addresses in&nbsp;CSV&nbsp;/ XLS&nbsp;/ XLSX format;{' '}
                  if&nbsp;you don&rsquo;t know which format to&nbsp;provide, click &rsquo;_example&rsquo;
                  or&nbsp;download an&nbsp;example CVS file.
                </ListItem>
                <ListItem>Click &rsquo;_continue&rsquo; and proceed to&nbsp;the next step.</ListItem>
              </List>

              <TitleList>2-approve</TitleList>
              <List>
                <ListItem>
                  Click the &rsquo;service&nbsp;conditions&rsquo; checkbox and then the &rsquo;_continue&rsquo; button.
                </ListItem>
              </List>

              <TitleList>3-airdrop</TitleList>
              <List>
                <ListItem>
                  Select &rsquo;Self-generated&rsquo; option and click &rsquo;_sign-key&rsquo;, after which you can{' '}
                  <b>download self generated backup</b> and confirm that by checking &rsquo;I saved private key&rsquo;
                  box. After that click the &rsquo;_continue&rsquo; button.
                </ListItem>
                <ListItem>
                  Airdrop step displays the complete airdrop information. Click &rsquo;_proceed&rsquo; and confirm the
                  transactions in&nbsp;your wallet.
                </ListItem>
                <ListItem>
                  Finished! There&rsquo;s nothing else for you to&nbsp;do. Just wait until all transactions are mined.
                </ListItem>
              </List>
            </>
          )}
        </Content>
      </Article>
    </>
  )
}

export { Tutorial }
